module.exports = __webpack_public_path__ + "static/img/007.4ea175e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/007.png
// module id = xTr8
// module chunks = 0